import { render, staticRenderFns } from "./QueryCRM.vue?vue&type=template&id=1d322a3e&scoped=true"
import script from "./QueryCRM.vue?vue&type=script&lang=js"
export * from "./QueryCRM.vue?vue&type=script&lang=js"
import style0 from "./QueryCRM.vue?vue&type=style&index=0&id=1d322a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d322a3e",
  null
  
)

export default component.exports